export function normalizeBrowserVersion(version: string | undefined): string | undefined {
	if (!version || !/^[\d.]+$/.test(version)) {
		return undefined;
	}
	const parts = version.split('.');
	while (parts.length < 2) {
		parts.push('0');
	}
	return parts
		.slice(0, 2)
		.map((part) => part.padStart(3, '0'))
		.join('.');
}
